export enum Actions {
	SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',
	SET_SEARCH_QUERY = 'SET_SEARCH_QUERY',
	SET_SELECTED_CLIENTS = 'SET_SELECTED_CLIENTS',
	SET_SELECTED_BRANCHES = 'SET_SELECTED_BRANCHES',
	SET_FILTERED_BRANCH_OFFICES = 'SET_FILTERED_BRANCH_OFFICES',
	SET_SHOW_PREVIEW = 'SET_SHOW_PREVIEW',
	SET_SAVING = 'SET_SAVING',
	DESELECT_CLIENT = 'DESELECT_CLIENT',
	SELECT_CLIENT = 'SELECT_CLIENT',
	DESELECT_ALL = 'DESELECT_ALL',
	HANDLE_BRANCH_OFFICES_CHANGE = 'HANDLE_BRANCH_OFFICES_CHANGE',
	SET_COMPANIES = 'SET_COMPANIES'
}

export default Actions;
